import { httpRequest } from "@services/http";

export interface RoleDetail {
  id: number;
  name: string;
  permissions: { feature_id: number; feature_name: string; level: number }[];
}

export class CommandGetRole {
  async run(roleId: number): Promise<RoleDetail> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/${roleId}`;
    try {
      return await httpRequest<RoleDetail>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching role:", error);
      throw error;
    }
  }
}
